import { NotificationBrowserTrackingApiHandler_saveEvent } from '@zg-rentals/ts-notification-client';
import { getClient } from '@zg-rentals/ts-client-http-client';
import { getCurrentEnvForClientSide, PRODUCTION } from '@zg-rentals/rental-platform-config';
import { getGlobalLogger } from '@zg-rentals/logger-browser';

export type RegisterNotificationParams = {
  ref: string;
};

/**
 * Registers a notification event when nid is present in the URL params. The URL will then be updated to remove the nid param.
 *
 * @example registerNotification({ ref: 'BROWSER_NEXT_SERVERLESS_DEMO_WEB' });
 */
export async function registerNotification({ ref }: RegisterNotificationParams) {
  const logger = getGlobalLogger();

  logger.info({ ref });

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return logger.info(`skipping registerNotification for ${ref} due to logic running on the server side`);
  }

  if (getCurrentEnvForClientSide() !== PRODUCTION) {
    return logger.info(`skipping registerNotification for ${ref} due to environment not being production`);
  }

  const url = new URL(window.location.href);
  const nid = url.searchParams.get('nid');
  if (typeof nid === 'string') {
    try {
      logger.info(`registering notification for ${ref}`);
      await NotificationBrowserTrackingApiHandler_saveEvent(
        { nid, ref, type: 'visited' },
        getClient().extend({
          prefixUrl: 'https://notification.hotpads.com',
          credentials: 'omit',
        }),
      );
    } catch (error) {
      logger.error({ error }, `error registering notification for ${ref}`);
    }

    // delete nid from url to prevent registering again
    url.searchParams.delete('nid');
    window.history.replaceState({}, '', url.toString());
  }
}
